export default (isoString: $TSFixMe) => new Date(isoString);
